import { ServerFetch } from '../main-model'

export default class DebitNoteCustomerListModel extends ServerFetch {
    getDebitNoteCustomerListBy = (data) => this.authFetch({
        url: 'debit-note-customer-list/getDebitNoteCustomerListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    generateDebitNoteCustomerListBy = (data) => this.authFetch({
        url: 'debit-note-customer-list/generateDebitNoteCustomerListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}